import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const TEAM_API = `${BACKEND_URL}/api`;

const teamApi = axios.create({ baseURL: TEAM_API });

teamApi.interceptors.request.use((config) => {
    const t = localStorage.getItem("du_team_token");
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

teamApi.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401 && window.location.pathname.startsWith("/equipe") && !window.location.pathname.startsWith("/equipe/login")) {
            localStorage.removeItem("du_team_token");
            window.location.href = "/equipe/login";
        }
        return Promise.reject(err);
    }
);

export default teamApi;
